import React from 'react';
const IconCommentWaitingFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 18H10V22H12.11L15.47 18H22V2H2V18ZM16 8.75C16.69 8.75 17.25 9.31 17.25 10C17.25 10.69 16.69 11.25 16 11.25C15.31 11.25 14.75 10.69 14.75 10C14.75 9.31 15.31 8.75 16 8.75ZM12 8.75C12.69 8.75 13.25 9.31 13.25 10C13.25 10.69 12.69 11.25 12 11.25C11.31 11.25 10.75 10.69 10.75 10C10.75 9.31 11.31 8.75 12 8.75ZM8 8.75C8.69 8.75 9.25 9.31 9.25 10C9.25 10.69 8.69 11.25 8 11.25C7.31 11.25 6.75 10.69 6.75 10C6.75 9.31 7.31 8.75 8 8.75Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconCommentWaitingFill;